import React from "react";
import SurveyNameComponent from "../Elements/SurveyNameComponent";
import FieldTypesEnum from "../Enums/FieldTypesEnum";
import TabListTableCellWidthEnum from "../Enums/TabListTableCellWidthEnum";
import UserNameComponent from "../Elements/UserNameComponent.js";
import dateTimeHelper from "../Helpers/datetimeHelper";

export default class SftpDatumItem {
  constructor(item) {
    if (item === undefined) {
      this.Id = "";
      this.OriginalJobId = "";
      this.NewJobId = "";
      this.SurveyId = "";
      this.FormName = "";
      this.UserLocId = "";
      this.CreatedInApollo = "";
      this.Status = ".";
      this.CreatedOn = "";
      this.CreatedBy = "";
      this.ModifiedOn = "";
      this.ModifiedBy = "";
      this.Error = "";
    } else {
      this.initialize(item);
    }
  }

  async initialize(item) {
    this.Id = item.id;
    this.OriginalJobId = item.originalJobId;
    this.NewJobId = item.newJobId;
    this.SurveyId = item.surveyId;
    this.FormName = item.formName;
    this.UserLocId = item.userLocId;
    this.CreatedInApollo = item.createdInApollo;
    this.Status = item.status;
    this.CreatedOn = item.createdOn;
    this.CreatedBy = item.createdBy;
    this.ModifiedOn = item.modifiedOn;
    this.ModifiedBy = item.modifiedBy;
    this.Error = item.error;
  }

  static NameOfTheIdField() {
    return "Id";
  }
  static nameOfTheItemDetailList() {
    return "Apollo Shop Copier History Item";
  }
  static MoneyFields = [];
  static Currency() {
    return "";
  }
  static MoneyFieldsSecondary = [];
  static CurrencySecondary() {
    return "";
  }
  static DateFields = ["CreatedOn", "ModifiedOn"];
  static BoolFields = [];

  static FieldsToShowInListTable = [
    {
      tabName: "Info",
      tabLabel: "Info",
      icon: "fa-solid fa-info",
      data: [
        { name: (item) => <UserNameComponent userId={item.CreatedBy} />, label: "CreatedBy" },
        { name: "CreatedOn", label: "CreatedBy" },
        { name: (item) => <UserNameComponent userId={item.ModifiedBy} />, label: "ModifiedBy" },
        { name: "ModifiedOn", label: "ModifiedOn" },
      ],
    },
    { tabName: "Error", tabLabel: "Error", icon: "fa-solid fa-circle-exclamation", data: [{ name: "Error", label: "Error", width: TabListTableCellWidthEnum.TwoLines }] },
  ];

  static FieldsToShowInDataTable() {
    return [
      { label: "Id", orderById: "Id", data: "Id", type: FieldTypesEnum.DataFieldWithDetails, minWidth: 50 },
      { label: "Original Job Id", orderById: "OriginalJobId", data: "OriginalJobId", className: "text-center" },
      { label: "New Job Id", orderById: "NewJobId", data: "NewJobId", minWidth: 50, className: "text-center" },
      { label: "Survey", orderById: "SurveyId", data: (item) => <SurveyNameComponent surveyId={item.SurveyId} />, className: "text-center", minWidth: 50 },
      { label: "User Loc Id", orderById: "UserLocId", data: "UserLocId", className: "text-center", minWidth: 50 },
      { label: "Created In Apollo", orderById: "CreatedInApollo", data: (item) => dateTimeHelper.toYYYYsMMsDDsHHsMMsSS(item.CreatedInApollo), className: "text-center" },
      { label: "Status", orderById: "Status", data: "Status", className: "text-center" },
    ];
  }

  // static getActionsContent(item)
  // {
  // 	return (
  // 		<div>
  // 			<FaIcon
  // 				iconName="fa-solid fa-edit"
  // 				className="pointer link"
  // 				tooltipText="Edit"
  // 				onClick={()=>SftpDatumItem.editFunction(item.SftpDataId,item)}
  // 			/>
  // 		</div>
  // 	);
  // }
}
